export default __webpack_public_path__ + "static/media/vishal1.bbc18c64.jpg";